import React from 'react';
import CeMarkPng from './CeMark.png';

export default function CeMark(props: any) {
  return <img src={CeMarkPng} alt="ce-mark" {...props} />;
}
